<template>
  <ElementLayout>
    <template #element>
      <button class="btn btn-primary" type="button" @click="selectHeadset">Choisir un casque</button>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
/// @ts-nocheck
import { Device } from '@/device';
import { useToastStore } from '@/stores/toast.store';
import { defineElement } from '@vueform/vueform';
import { Ref, ref, toRaw } from 'vue';

export default defineElement({
  name: 'HeadsetElement',
  emits: ['headset-selected'],
  nullValue: false,
  setup(_: unknown, { element }: { element: unknown }) {
    const { update, fire } = element as {
      update: (value: boolean) => void;
      fire: (event: string, value: Device) => void;
    };
    const toast = useToastStore();
    const device: Ref<Device | null> = ref(null);

    const selectHeadset = async () => {
      device.value = device.value ?? new Device();
      const selected = await toRaw(device.value).selectDevice();
      if (selected) {
        try {
          await toRaw(device.value).connect();
          update(true);
          fire('headset-selected', toRaw(device.value));
        } catch (error) {
          console.error(error);
          toast.addToast({
            title: 'Erreur lors de la selection du casque',
            message: error.message,
            type: 'danger',
            duration: 5000,
          });
          update(false);
        }
      } else {
        update(false);
      }
    };
    return { selectHeadset };
  },
});
</script>
